import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'

@Injectable()
export class StateServices {
    tabName: any = ''
    hash: any[] = []

    jsonSaveFormSetting: any
    oldDataSearch: any
    idsSearchTabs: any
    isShowtableSelect: any
    enableBehavior: any = 'false'

    arrImageHash: any[] = []

    viewAligner = ''

    dataHash
    ratatepropertyName

    private searchTabIds: any = {}
    UseSearchPageList = {
        SELECT_CLIENT: {
            id: 1,
            pageName: 'select-client',
        },
        ALIGNER_CLINIC: {
            id: 2,
            pageName: 'aligner-clinic',
        },
        ALIGNER_CLIENT_DETAIL: {
            id: 3,
            pageName: 'aligner-client-detail',
        }
    }
    constructor() {

    }

    changeEmittedHash$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedArrImageHash$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedTabName$: BehaviorSubject<any> = new BehaviorSubject('')

    changeEmittedIsSakura$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedResetValueMatrix$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedArrayFormSetting$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedjsonDataSaveFormSetting$: BehaviorSubject<any> = new BehaviorSubject('')

    changeEmittedDataSearchAligner$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedListSettingTabs$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedIdsSearchTabs$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedIsShowTableSelect$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedDefaultArrSelect$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedUpdateAligner$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedDataFormTimeline$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedStaffCharge$: BehaviorSubject<any> = new BehaviorSubject(null)
    changeEmittedValueStaffCharge$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedFirstLoading$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedDeletePropertyName$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedDeleteTimeline$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedViewAligner$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedRefreshAligner$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedProfileSave$: BehaviorSubject<any> = new BehaviorSubject(null)

    changeEmittedRatatepropertyName$: BehaviorSubject<any> = new BehaviorSubject(null)


    emitChangeHash(change: any[] = []) {
        this.hash = []
        if (this.hash && change != null) {
            const check: any = this.comparison(this.hash, change[this.tabName])
            if (check == false) {
                const tmp: any[] = change[this.tabName]
                tmp.forEach(el => {
                    this.hash.push(el)
                })
                this.dataHash = change
                this.changeEmittedHash$.next(change)
            }
        } else {
            if (change != null) {
                const tmp: any[] = change[this.tabName]
                tmp.forEach(el => {
                    this.hash.push(el)
                })
            }
            this.dataHash = change
            this.changeEmittedHash$.next(change)
        }
    }

    returnDataHash() {
        return this.dataHash
    }

    emitChangeRatatepropertyName(change: any) {
        this.ratatepropertyName = change
        this.changeEmittedRatatepropertyName$.next(change)
    }

    returnRatatepropertyName() {
        return this.ratatepropertyName
    }

    emitChangeProfileSave(change: any) {
        this.changeEmittedProfileSave$.next(change)
    }

    emitChangeViewAligner(change: any) {
        this.viewAligner = change
        this.changeEmittedViewAligner$.next(change)
    }

    returnViewAligner() {
        return this.viewAligner
    }

    emitChangeRefreshAligner(change: any) {
        this.changeEmittedRefreshAligner$.next(change)
    }

    emitChangeDeleteTimeline(change: any) {
        this.changeEmittedDeleteTimeline$.next(change)
    }

    emitChangeDeletePropertyName(change: any) {
        this.changeEmittedDeletePropertyName$.next(change)
    }

    emitChangeFirstLoading(change: any) {
        this.changeEmittedFirstLoading$.next(change)
    }

    emitChangeResetValueMatrix(change: any) {
        this.changeEmittedResetValueMatrix$.next(change)
    }

    emitChangeArrImageHash(change: any) {
        this.arrImageHash = change
        this.changeEmittedArrImageHash$.next(change)
    }

    returnArrImageHash() {
        return this.arrImageHash
    }

    emitChangeEnableBehavior(change: any) {
        if (change && change['enableBehavior']) {
            this.enableBehavior = change['enableBehavior']
        } else {
            this.enableBehavior = 'false'
        }
        this.changeEmittedIsSakura$.next(change)
    }

    returnEnableBehavior() {
        return this.enableBehavior
    }

    emitChangeDataFormTimeline(change: any) {
        this.changeEmittedDataFormTimeline$.next(change)
    }

    emitChangeStaffCharge(change: any) {
        this.changeEmittedStaffCharge$.next(change)
    }

    emitChangeValueStaffCharge(change: any) {
        this.changeEmittedValueStaffCharge$.next(change)
    }

    emitChangeUpdateAligner(change: any) {
        this.changeEmittedUpdateAligner$.next(change)
    }

    emitChangeDefaultArrSelect(change: any) {
        this.changeEmittedDefaultArrSelect$.next(change)
    }

    emitChangeIdsSearchTabs(change: any) {
        this.idsSearchTabs = change
        this.changeEmittedIdsSearchTabs$.next(change)
    }

    returnIdsSearchTabs() {
        return this.idsSearchTabs
    }

    emitChangeIsShowTableSelect(change: any) {
        this.isShowtableSelect = change
        this.changeEmittedIsShowTableSelect$.next(change)
    }

    returnIsShowTableSelect() {
        return this.isShowtableSelect
    }

    emitChangeTabName(change: any) {
        this.tabName = change
        this.changeEmittedTabName$.next(change)
    }

    comparison(array1: any[] = [], array2: any[] = []) {
        let tmpArr: any[] = []
        array1.forEach(el1 => {
            tmpArr = array2.filter(el2 => {
                return JSON.stringify(el1) == JSON.stringify(el2)
            })
        })
        if (tmpArr.length == array2.length) {
            return true
        }
        return false
    }

    getTabName() {
        return this.tabName
    }

    emitChangeArrayFormSetting(change: any) {
        if (change && change['jsonDataSave']) {
            this.jsonSaveFormSetting = change['jsonDataSave']
        }
        this.changeEmittedArrayFormSetting$.next(change)
    }

    emitChangeJsonSaveFormSetting(change: any) {
        if (change && change['jsonDataSave']) {
            this.jsonSaveFormSetting = change['jsonDataSave']
        }
        this.changeEmittedjsonDataSaveFormSetting$.next(change)
    }

    returnArrayFormSetting() {
        return this.jsonSaveFormSetting
    }

    emitChangeListSettingTabs(change: any) {
        this.changeEmittedListSettingTabs$.next(change)
    }

    getData() {
        return this.changeEmittedDataSearchAligner$.asObservable()
    }

    emitChangeDataSearchAligner(change: any) {
        this.changeEmittedDataSearchAligner$.next(change)
    }

    resetData() {
        this.arrImageHash = []
        this.viewAligner = ''
        this.dataHash = []
        // this.isShowtableSelect = undefined
        this.jsonSaveFormSetting = undefined
        this.oldDataSearch = undefined
        this.idsSearchTabs = undefined
    }

    checkEnableSettingBehaviour(userId) {
        // enable setting behaviour by user
        // const listEnableSettingBehaviour: any[] = ENABLE_SETTING_BEHAVIOUR;
        // const checkEnable = listEnableSettingBehaviour.findIndex(el => {
        //     return el['_id'] == userId;
        // });
        // if (checkEnable != -1) {
        //     return 'true';
        // }
        // return 'false';

        // set default all user can uses behaviour
        return 'true'
    }

    getSearchTabIdsByPageNameUse(pageNameUse: string): {
        arrIdClickedTabs?: any[],
        arrayAlignerTabs?: any[],
        jsonDataSearch?: any,
    } | undefined {
        return this.searchTabIds[pageNameUse]
    }

    emitChangeSearchTabIdsByPageNameUse(pageNameUse: string, change: {
        arrIdClickedTabs?: any[],
        arrayAlignerTabs?: any[],
        jsonDataSearch?: any,
    }) {
        this.searchTabIds[pageNameUse] = change
    }

    resetAllSearchTabIds() {
        this.searchTabIds = {}
    }
}



// WEBPACK FOOTER //
// ./src/app/services/state.services.ts